const BASE = import.meta.env.VITE_AZURE_ENDPOINT;
const KEY = import.meta.env.VITE_AZURE_API_KEY;
const DEP = "text-embedding-ada-002";

export async function embed(text: string, signal?: AbortSignal) {
  const r = await fetch(
    `${BASE}/openai/deployments/${DEP}/embeddings?api-version=2024-02-15-preview`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", "api-key": KEY },
      body: JSON.stringify({ input: text }),
      signal,
    }
  );
  if (!r.ok) throw new Error(await r.text());
  const v = (await r.json()).data[0].embedding as number[];
  return new Float32Array(v);
}

export function cosine(a: Float32Array, b: Float32Array) {
  let dot = 0,
    na = 0,
    nb = 0;
  for (let i = 0; i < a.length; i++) {
    dot += a[i] * b[i];
    na += a[i] * a[i];
    nb += b[i] * b[i];
  }
  return dot / (Math.sqrt(na) * Math.sqrt(nb));
}
